// This is a plugin that adds a $fetchPeriodically method to Vue instances
async function fetchDataFromServer(vm) {
    if (vm.$store.getters.isLoggedIn) {
        return vm.$rq.getUpdateInfo();
    }
    return null;
}
export default {
    install(Vue) {
        Vue.prototype.$fetchPeriodically = function fetchPeriodically() {
            const fetchInterval = 1800000;
            const vm = this;
            setInterval(() => {
                // Replace this with your actual server fetch call
                fetchDataFromServer(vm).then(data => {
                    if (vm.processFetchedData) {
                        vm.processFetchedData(data);
                    }
                }).catch(error => {
                    throw error;
                });
            }, fetchInterval);
        };
    },
};
